module.exports = __webpack_public_path__ + "static/img/girl.f4ee72c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/girl.png
// module id = ztYC
// module chunks = 1